import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LanguageWrapper from "../components/LanguageWrapper";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/ja" replace />,
  },
  {
    path: "/:lang",
    element: <LanguageWrapper />,
    children: [
      {
        index: true,
        element: <Home />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
